/**
 * Label position values exposed by {@link Field}.
 */
export const LabelPositions = {
    above: "above",
    after: "after",
    before: "before"
};
/**
 * Back-compat aliases preserving the Field-prefixed naming used previously.
 */
export const FieldLabelPositions = LabelPositions;
export const FieldLabelPosition = LabelPositions;
/**
 * Validation state flags surfaced by {@link Field}.
 */
export const ValidationFlags = {
    badInput: "bad-input",
    customError: "custom-error",
    patternMismatch: "pattern-mismatch",
    rangeOverflow: "range-overflow",
    rangeUnderflow: "range-underflow",
    stepMismatch: "step-mismatch",
    tooLong: "too-long",
    tooShort: "too-short",
    typeMismatch: "type-mismatch",
    valueMissing: "value-missing",
    valid: "valid"
};
/**
 * Synthetic entry describing the structural requirements for slotted inputs.
 * Provides a plural const so option-normalization rules can derive {@link SlottableInput}.
 */
export const SlottableInputs = {
    structural: undefined
};
//# sourceMappingURL=field.options.js.map